var $b63be9b0371e788c$exports = {};
const $b63be9b0371e788c$var$codeSolution = "datacrate";
const $b63be9b0371e788c$var$bombCodeSolution = "fsdg";
const $b63be9b0371e788c$var$wrongBombCodeKeys = "wa";
const $b63be9b0371e788c$var$startTime = Date.now();
const $b63be9b0371e788c$var$totalTime = 2700000; // in ms
let $b63be9b0371e788c$var$remainingAttemps = 3;
let $b63be9b0371e788c$var$updateTimerInterval;
document.addEventListener("DOMContentLoaded", ()=>{
    document.getElementById("submit-code").addEventListener("click", ()=>{
        try {
            const code = document.getElementById("code").value.toLowerCase();
            if (code === $b63be9b0371e788c$var$codeSolution) $b63be9b0371e788c$var$onFoundCode();
        } catch (e) {}
        document.getElementById("code").value = "s";
    });
    $b63be9b0371e788c$var$updateTimerInterval = window.setInterval($b63be9b0371e788c$var$updateTimer, 1000);
});
function $b63be9b0371e788c$var$onFoundCode() {
    document.getElementById("code-entry").classList.add("display-none");
    document.getElementById("bomb").classList.remove("display-none");
    $b63be9b0371e788c$var$updateStatusText();
    document.addEventListener("keydown", $b63be9b0371e788c$var$onKeyDown);
    document.addEventListener("keyup", $b63be9b0371e788c$var$onKeyUp);
}
function $b63be9b0371e788c$var$updateTimer() {
    const remainingMs = $b63be9b0371e788c$var$totalTime - (Date.now() - $b63be9b0371e788c$var$startTime);
    if (remainingMs < 0) $b63be9b0371e788c$var$onGameOver();
    else {
        const min = Math.floor(remainingMs / 60000);
        const sec = Math.floor(remainingMs / 1000 % 60);
        document.getElementById("timer").innerText = `${min.toString().padStart(2, "0")}:${sec.toString().padStart(2, "0")}`;
    }
}
const $b63be9b0371e788c$var$keysDown = new Set();
function $b63be9b0371e788c$var$onKeyDown(event) {
    console.log(event);
    $b63be9b0371e788c$var$keysDown.add(event.key);
    $b63be9b0371e788c$var$updateKeySelection();
}
function $b63be9b0371e788c$var$onKeyUp(event) {
    console.log(event);
    $b63be9b0371e788c$var$keysDown.delete(event.key);
    $b63be9b0371e788c$var$updateKeySelection();
}
function $b63be9b0371e788c$var$updateKeySelection() {
    if (Array.from($b63be9b0371e788c$var$wrongBombCodeKeys).some((key)=>$b63be9b0371e788c$var$keysDown.has(key))) $b63be9b0371e788c$var$onWrongBombCode();
    else if (Array.from($b63be9b0371e788c$var$bombCodeSolution).every((key)=>$b63be9b0371e788c$var$keysDown.has(key))) $b63be9b0371e788c$var$onFoundBombCode();
    $b63be9b0371e788c$var$updateStatusText();
}
function $b63be9b0371e788c$var$cancelTimer() {
    window.clearInterval($b63be9b0371e788c$var$updateTimerInterval);
}
function $b63be9b0371e788c$var$onGameOver() {
    $b63be9b0371e788c$var$cancelTimer();
    document.addEventListener("keydown", $b63be9b0371e788c$var$onKeyDown);
    document.addEventListener("keyup", $b63be9b0371e788c$var$onKeyUp);
    document.getElementById("code-entry").classList.add("display-none");
    document.getElementById("bomb").classList.add("display-none");
    document.getElementById("game-over").classList.remove("display-none");
}
function $b63be9b0371e788c$var$onWrongBombCode() {
    $b63be9b0371e788c$var$remainingAttemps--;
    if ($b63be9b0371e788c$var$remainingAttemps <= 0) $b63be9b0371e788c$var$onGameOver();
}
function $b63be9b0371e788c$var$onFoundBombCode() {
    $b63be9b0371e788c$var$cancelTimer();
    document.addEventListener("keydown", $b63be9b0371e788c$var$onKeyDown);
    document.addEventListener("keyup", $b63be9b0371e788c$var$onKeyUp);
    document.getElementById("code-entry").classList.add("display-none");
    document.getElementById("bomb").classList.add("display-none");
    document.getElementById("success").classList.remove("display-none");
}
function $b63be9b0371e788c$var$updateStatusText() {
    let statusText = `<p>Connected ${$b63be9b0371e788c$var$keysDown.size} / 4</p>`;
    statusText += `<p>Remaining attempts: ${$b63be9b0371e788c$var$remainingAttemps}</p>`;
    document.getElementById("bomb-status-text").innerHTML = statusText;
}


//# sourceMappingURL=index.08933d8d.js.map
